export enum CreatorEvents {
    AddSlideElement = "AddSlideElement",
    AddSlide = "AddSlide",
    UpdateSlideMetadata = "UpdateSlideMetadata",
    DeleteSlideElement = "DeleteSlideElement",
    DeleteSlide = "DeleteSlide",
    UpdateSlideElement = "UpdateSlideElement",
    SetSlideNavigation = "SetSlideNavigation",
    AnimationUpdate = "AnimationUpdate",

    ReloadSlide = "ReloadSlide",

    ShowAddImage = "ShowAddImage",
    ShowAddText = "ShowAddText",
    ShowAddExisting = "ShowAddExisting",
    ShowEditCss = "ShowEditCss",
    ShowEditHtml = "ShowEditHtml",

    ShowInsertQuestionBefore = "ShowInsertQuestionBefore",
    ShowInsertQuestionAfter = "ShowInsertQuestionAfter",

    ChooseNextSlide = "ChooseNextSlide",

    SelectKeyFrames = "SelectKeyFrames",
    SelectedKeyFrames = "SelectedKeyFrames",
    CreateKeyFrame = "CreateKeyFrame",
    UpdateKeyFrame = "UpdateKeyFrame",
    DeleteKeyFrame = "DeleteKeyFrame",

    SelectSlideElements = "SelectSlideElements",
    SelectedSlideElements = "SelectedSlideElements",
    UpdateSlideCaptions = "UpdateSlideCaptions",
    UpdateSlideHtml = "UpdateSlideHtml",
    UpdateSlideNotes = "UpdateSlideNotes",
    UpdateSlideAudio = "UpdateSlideAudio",

    QuestionsUpdate = "QuestionsUpdate",
    UpdateCss = "UpdateCss",

    StatusUpdate = "StatusUpdate",

    DeclareVariable = "DeclareVariable",
    RemoveVariable = "RemoveVariable"
}